import { render, staticRenderFns } from "./SharerRateTierCard.vue?vue&type=template&id=b6c0da10&scoped=true"
import script from "./SharerRateTierCard.vue?vue&type=script&lang=js"
export * from "./SharerRateTierCard.vue?vue&type=script&lang=js"
import style0 from "./SharerRateTierCard.vue?vue&type=style&index=0&id=b6c0da10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c0da10",
  null
  
)

export default component.exports